;(() => {
	const GLOBAL = {
		screen: { md: () => window.matchMedia('(max-width: 1180px)').matches },
		context: {}, // já garante que existe
	}
	window.GLOBAL = window.GLOBAL || GLOBAL
})()
